import {Component, Input, OnInit, Output} from '@angular/core';
import {
  fdeClientRequestNavObject,
} from "../../../../../common/it-interface";
import {convertToSnakeCase} from "../../../../../common/it-utils";
import {SIDE_NAV_TITLES} from "../../../../../common/it-constants";

@Component({
  selector: 'app-cr-nav-table',
  templateUrl: './cr-nav-table.component.html',
  styleUrls: ['./cr-nav-table.component.scss']
})
export class CrNavTableComponent implements OnInit {

  @Input() tableDataShow: string;
  @Input() listOfFdeCrNavByHstDate: fdeClientRequestNavObject[];

  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  constructor() { }

  ngOnInit() {
    this.listOfFdeCrNavByHstDate = [];
  }

}
